import React from 'react';

import { css, cx } from '@emotion/css';
import { useFormContext } from 'react-hook-form';

import { Icons } from '@/assets/icons.ts';
import { IconButton } from '@/components/button/IconButton.tsx';
import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';

export type MessageBoxSendButtonProps = {
  className?: string;
};

export const MessageBoxSendButton: React.FC<MessageBoxSendButtonProps> = ({
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { formState } = useFormContext();
  const sendDisabled = formState.disabled || formState.isSubmitting;

  return (
    <div className={cx(styles.container, className)}>
      <IconButton
        className={cx({
          [styles.sendButton]: true,
          [styles.disabledSendButton]: sendDisabled,
        })}
        iconClassname={cx({
          [styles.disabledSendButtonIcon]: sendDisabled,
        })}
        status={'success'}
        icon={Icons.sendMessage}
        placement="left"
        buttonType="primary"
        type="submit"
        disabled={sendDisabled}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  }),
  sendButton: css`
    border-radius: ${theme.spacing(12)};
    padding: ${theme.spacing(4)};
    aspect-ratio: 1;
  `,
  disabledSendButtonIcon: css`
    stroke: ${theme.palette.action.disabled};
  `,
  disabledSendButton: css`
    border-color: ${theme.palette.common.white};
  `,
});
